<div class="row">
  <div class="col-md-12">
      <yt-userprovajder-inline-update #baseInlineUpdate></yt-userprovajder-inline-update>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <yt-fw-default-detail-list-inline 
    #baseDetailList
    [Model]="modelData.MainList.DetailList[0]" 
    [ParentPropertyName]="_parentPropertyName"
    [ParentPropertyValue]="_parentPropertyValue" 
    [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0"
    (Items)="setItems($event)">
</yt-fw-default-detail-list-inline>
  </div>
